<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
  <div class="orangehrm-top-padding">
    <oxd-text tag="h6" class="orangehrm-main-title">
      {{ $t('pim.add_contract') }}
    </oxd-text>
    <oxd-divider />
    <oxd-form :loading="isLoading" @submitValid="onSave">
      <oxd-form-row>
        <oxd-grid :cols="2" class="orangehrm-full-width-grid">
          <oxd-grid-item>
            <date-input
              v-model="contract.startDate"
              :label="$t('pim.contract_start_date')"
              :disabled="isEmployee"
              :required="true"
            />
          </oxd-grid-item>

          <oxd-grid-item>
            <date-input
              v-model="contract.endDate"
              :label="$t('pim.contract_end_date')"
              :disabled="isEmployee"
            />
          </oxd-grid-item>
        </oxd-grid>
      </oxd-form-row>
      <oxd-form-row>
        <oxd-grid :cols="1" class="orangehrm-full-width-grid">
          <oxd-grid-item>
            <!--
            <file-upload-input
              v-model:newFile="contract.newAttachment"
              v-model:method="contract.method"
              :label="$t('pim.contract_details')"
              :button-label="$t('general.browse')"
              :file="contract.oldAttachment"
              :url="`pim/viewAttachment/empNumber/${empNumber}/attachId`"
              ref="fileInput"
              hint="Accepts up to 1MB"
            />
            -->
            <file-input
              v-model="file"
              :is-single="true"
              placeholder="Select file"
              :required="true"
            />
            <!-- <input type="file" ref="fileInput" @change="setFile" :required="true"/> -->
          </oxd-grid-item>
        </oxd-grid>
      </oxd-form-row>
      <br />
      <oxd-form-actions>
        <oxd-button
          type="button"
          display-type="ghost"
          label="Cancel"
          @click="onCancel"
        />
        <submit-button :disabled="isDisabled" />
      </oxd-form-actions>
    </oxd-form>
    <oxd-divider />
  </div>
</template>

<script>
// import FileUploadInput from '@/core/components/inputs/FileUploadInput';
import {
  required,
  validSelection,
  maxFileSize,
  validFileTypes,
  validDateFormat,
  endDateShouldBeAfterStartDate,
} from '@ohrm/core/util/validation/rules';
import fileInput from './FileInput';

const contractModel = {
  startDate: '',
  endDate: '',
  currentContractAttachment: null,
  contractAttachment: null,
  oldAttachment: null,
  newAttachment: null,
  method: 'keepCurrent',
};

export default {
  name: 'SaveEmployeeContract',

  components: {
    //   'report-to-employee-autocomplete': contractEmployeeAutocomplete,
    // 'file-upload-input': FileUploadInput,
    'file-input': fileInput,
  },

  props: {
    http: {
      type: Object,
      required: true,
    },
    reportingMethods: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    empNumber: {
      type: String,
      required: true,
    },
  },

  emits: ['close'],

  setup(props) {
    const api = `api/v2/pim/employees/${props.empNumber}/report-to/allowed`;
    return {
      api,
    };
  },

  data() {
    return {
      isLoading: false,
      contract: {...contractModel},
      rules: {
        joinedDate: [validDateFormat(this.userDateFormat)],
        startDate: [validDateFormat(this.userDateFormat)],
        endDate: [
          validDateFormat(this.userDateFormat),
          endDateShouldBeAfterStartDate(() => this.contract.startDate),
        ],
        contractAttachment: [
          v => {
            if (this.contract.method == 'replaceCurrent') {
              return required(v);
            } else {
              return true;
            }
          },
          validFileTypes(this.allowedFileTypes),
          maxFileSize(this.maxFileSize),
        ],
      },
      file: null,
    };
  },

  computed: {
    isDisabled() {
      if (this.file == null) return true;

      if (this.contract.startDate == null) return true;

      return false;
    },
  },

  methods: {
    setFile() {
      this.file = this.$refs.fileInput.files[0];
    },
    onSave() {
      this.isLoading = true;
      /*
      this.http.request({
        method: 'PUT',
        url: `api/v2/pim/employees/${this.empNumber}/employment-contract`,
        data: {
          startDate: this.contract.startDate,
          endDate: this.contract.endDate,
          currentContractAttachment: this.contract.oldAttachment
            ? this.contract.method
            : undefined,
          contractAttachment: this.contract.newAttachment
            ? this.contract.newAttachment
            : undefined,
        },
      });
      */

      const formData = new FormData();
      formData.append('startDate', this.contract.startDate);
      formData.append('endDate', this.contract.endDate);
      formData.append('file', this.file);

      this.http
        .request({
          method: 'POST',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `api/v2/pim/employees/${this.empNumber}/contracts`,
          data: formData,
        })
        .then(response => {
          this.$emit('close', true);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onCancel() {
      this.$emit('close', true);
    },
  },
};
</script>
